!function ($) {
  var defaults = {
    trigger: "onload",
    animation: "fade",
    delay: 100,
    showOnce: !1,
    autoClose: !1,
    scrollableModal: !1
  };

  $.fn.websenseprosubscribe = function (options) {
    var settings = $.extend({}, defaults, options),
      $element = $(this),
      hasShown = !1,
      isAnimating = !1;

    $element.addClass("sb");

    $.fn.openWindow = function () {
      if ($(this).is(":hidden") && !hasShown && !isAnimating) {
        isAnimating = !0;
        setTimeout(function () {
          if (settings.scrollableModal) {
            if ($(".sb-overlay").length < 1) {
              $("body").append("<div class='sb-overlay'><div class='sb-close-backdrop'></div><div class='sb sb-withoverlay'>" + $(".sb").html() + "</div></div>");
              $(".sb-close-backdrop, .sb-close-btn").one("click", function () {
                $(".sb.sb-withoverlay").closeWindow();
                return !1;
              });
              $(".sb.sb-withoverlay").removeClass("sb-animation-" + settings.animation.replace("In", "Out")).addClass("sb-animation-" + settings.animation);
              setTimeout(function () {
                $(".sb.sb-withoverlay").show();
                $("body").addClass("sb-open sb-open-with-overlay");
              }, 300);
            }
          } else {
            if ($(".sb-overlay").length < 1) {
              $("body").append("<div class='sb-overlay'><div class='sb-close-backdrop'></div></div>");
              $(".sb").removeClass("sb-animation-" + settings.animation.replace("In", "Out")).addClass("sb-animation-" + settings.animation);
              $(".sb-close-backdrop, .sb-close-btn").one("click", function () {
                $(".sb").closeWindow();
                return !1;
              });
              setTimeout(function () {
                $(".sb").show();
                $("body").addClass("sb-open");
              }, 300);
            }
          }
          if (settings.showOnce) {
            hasShown = !0;
          }
          isAnimating = !1;
        }, settings.delay);
      }
    };

    $.fn.closeWindow = function () {
      if ($(this).is(":visible") && !isAnimating) {
        isAnimating = !0;
        if (settings.scrollableModal) {
          $(".sb.sb-withoverlay").removeClass("sb-animation-" + settings.animation).addClass("sb-animation-" + settings.animation.replace("In", "Out"));
          setTimeout(function () {
            $(".sb.sb-withoverlay").hide();
            $("body").removeClass("sb-open sb-open-with-overlay");
            setTimeout(function () {
              $(".sb-overlay").remove();
            }, 300);
          }, 300);
        } else {
          $(".sb").removeClass("sb-animation-" + settings.animation).addClass("sb-animation-" + settings.animation.replace("In", "Out"));
          setTimeout(function () {
            $(".sb").hide();
            $("body").removeClass("sb-open");
            setTimeout(function () {
              $(".sb-overlay").remove();
            }, 300);
          }, 300);
        }
        isAnimating = !1;
      }
    };

    $.fn.scrollDetection = function (eventType, callback) {
      var timer,
        lastScrollTime = new Date().getTime();
      $(window).scroll(function () {
        var currentScrollTime = new Date().getTime();
        if (currentScrollTime - lastScrollTime > 400) {
          $(this).trigger("scrollStart");
          lastScrollTime = currentScrollTime;
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
          $(window).trigger("scrollEnd");
        }, 300);
      });
      if (eventType === "scrollStart") {
        $(window).bind("scrollStart", function () {
          $(window).unbind("scrollEnd");
          callback();
        });
      }
      if (eventType === "scrollEnd") {
        $(window).bind("scrollEnd", function () {
          $(window).unbind("scrollStart");
          callback();
        });
      }
    };

    switch (settings.trigger) {
      case "open":
        $element.openWindow();
        break;
      case "atendpage":
        $(window).scroll(function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop >= $(document).height() - $(window).height()) {
            $element.openWindow();
          } else if (scrollTop + 300 < $(document).height() - $(window).height() && settings.autoClose) {
            $element.closeWindow();
          }
        });
        break;
      case "onload":
        $(window).on("load", function () {
          $element.openWindow();
          if (settings.autoClose) {
            $element.scrollDetection("scrollStart", function () {
              $element.closeWindow();
            });
          }
        });
        break;
      case "onidle":
        $(window).on("load", function () {
          $element.scrollDetection("scrollEnd", function () {
            $element.openWindow();
          });
          if (settings.autoClose) {
            $element.scrollDetection("scrollStart", function () {
              $element.closeWindow();
            });
          }
        });
        break;
    }
  };

  function setPopupShown(isShown = true) {
    var expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 7);
    var popupData = {
      shown: isShown,
      expire: isShown ? expireDate.getTime() : null
    };
    localStorage.setItem('popupShown', JSON.stringify(popupData));
  }

  function isPopupShown() {
    var popupData = JSON.parse(localStorage.getItem('popupShown'));
    if (popupData && popupData.shown) {
      var now = new Date().getTime();
      if (now < popupData.expire) {
        return true;
      }
    }
    return false;
  }


  $(document).ready(function () {

    if (window.location.pathname !== '/challenge') {

      function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      let isGeoBlockClicked = getCookie('isGeoBlockClicked') === "true";
      let isGeoBlockShow = false

      
      setTimeout(function() {
        const geoModal = document.querySelector('#geoModal');

        if (geoModal && geoModal.hasAttribute('open')) {
            isGeoBlockShow = true
        }
        if (!isPopupShown() && window.location.pathname !== '/' && (isGeoBlockClicked || !isGeoBlockShow)) {
          $(".subscribe-me").websenseprosubscribe({  trigger: "open"});
          setPopupShown();
        }
      }, 3000); 

      document.addEventListener('geoRedirectClosed', function () {
        if (!isPopupShown()) {
          setTimeout(() => {
            $(".subscribe-me").websenseprosubscribe({
              trigger: "open"
            });
            setPopupShown();
          }, 100);
        } 
      });
    }
  });
}(window.jQuery);
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ContactPopup');
  const messageContainer = form.querySelector('#Message-block-popup');

  const successMessage = document.getElementById('ContactPopup-success');
  const errorMessage = document.getElementById('ContactPopup-error');

  form.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form from submitting the traditional way
    errorMessage.style.display = 'none';

    const email = form.querySelector('input[name="contact[email]"]').value;
    const lang = document.querySelector('input[name="locale_code"]').value;

    if (!validateEmail(email)) {
      // If email is not valid
      form.classList.add("submit-error")
      messageContainer.classList.add("error")
      errorMessage.style.display = 'flex';
      errorMessage.querySelector('.message-text').textContent = 'Please enter a valid email address.';
      return;
    }

    // Define the new endpoint for subscription
    const subscriptionEndpoint =  window.subscriptionEndpoint; // Replace with your actual endpoint

    // AJAX call to custom endpoint for adding newsletter subscriber
    fetch(subscriptionEndpoint, {
      method: 'POST',
      body: JSON.stringify({ action: 'add-subscriber',email: email, lang:lang }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        // If response is not OK (e.g., 400 Bad Request), handle the error
        return response.json().then(data => {
          throw data;
        });
      }
      return response.json();
    })
    .then(data => {

      if (data.success) {
        // If the response indicates success
        form.classList.add("submit-success")
        messageContainer.classList.add("success")
        successMessage.style.display = 'block';
        errorMessage.style.display = 'none';
        successMessage.querySelector('.message-text').textContent ="Thank you for subscription!";
      }else if (!data.success) {
        form.classList.add("submit-error")
        messageContainer.classList.add("error")
        errorMessage.style.display = 'flex';
        successMessage.style.display = 'none';
        errorMessage.querySelector('.message-text').textContent = "This email address is already subscribed.";
      }
       else {
        // Handle unexpected responses
        throw new Error('Unexpected response format');
      }
    })
    .catch(data => {
      form.classList.add("submit-error")
      messageContainer.classList.remove("success")
      messageContainer.classList.add("error")
      
      
      // Check for error messages and display them
      if (data.message) {
        errorMessage.querySelector('.message-text').textContent = "Too many attempts. Please try again later.";
      } else {
        errorMessage.querySelector('.message-text').textContent = 'An error occurred. Please try again.';
      }
      errorMessage.style.display = 'flex';
      successMessage.style.display = 'none';
    });
  });

  // Function to validate email format
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
});
